import { getRules, getRuleTypeName } from "Utils/activityHelper";
import { formatPrice } from "Utils/common";
import checkedImg from "Images/checkedRule.svg";

interface TieredRule {
  activityType: string;
  activityTypeName: string;
  activityTypeDescription: string;
  promoType: string;
  exchangePromoType: string;
  exchangeTypeDescription: string;
  tieredRules: {
    id: number;
    activityId: number;
    activityCondition: number;
    promoTypeValue: number;
    exchangeMaxQty: number;
    exchangePromoTypeValue: number;
    activityProductRule?: any[];
    exchangeProductRule?: any[];
  }[];
}
const PromotionRules: React.FC<{
  activityId?: number | string;
  tieredRule: TieredRule;
  activityDetail?: any;
  matchStatus?: boolean;
  allowLinearTier?: boolean;
  currentTieredRule?: {
    id: number;
    [key: string]: any;
  };
}> = (props) => {
  const { activityDetail } = props;
  const allowLinearTier = activityDetail.allowLinearTier;
  const basicType = activityDetail?.activityBasicType;
  const getPromotionRules = (
    tieredRule: TieredRule,
    allowLinearTier?: boolean
  ) => {
    const { activityType, promoType, exchangePromoType, tieredRules } =
      tieredRule;

    // promoTypeUnit by activityType
    // promoTypeValueUnit by promoType
    let promoTypeUnitSuffix = "";
    let promoTypeUnitPrefix = "";
    let promoTypeValuePrefix = "";
    let promoTypeValueSuffix = "";
    let exchangePromoTypeValuePrefix = "";
    let exchangePromoTypeValueSuffix = "";
    let isConditionPrice = false;
    let isPromoValuePrice = false;

    switch (activityType) {
      case "reach_amount":
        promoTypeUnitPrefix = allowLinearTier
          ? "购买产品金额每满"
          : "购买产品金额满";
        promoTypeUnitSuffix = "元";
        isConditionPrice = true;
        break;
      case "reach_item":
        promoTypeUnitPrefix = allowLinearTier
          ? "购买产品种类每满"
          : "购买产品种类满";
        promoTypeUnitSuffix = "款";
        break;
      case "reach_quantity":
        promoTypeUnitPrefix = allowLinearTier
          ? "购买产品数量每满"
          : "购买产品数量满";
        promoTypeUnitSuffix = "件";
        break;
    }
    switch (promoType) {
      case "promo_discount":
        promoTypeValuePrefix = "产品享";
        promoTypeValueSuffix = "折优惠";
        break;
      case "promo_bundled_price":
        promoTypeValuePrefix = "产品享固定价";
        promoTypeValueSuffix = "元";
        break;
      case "promo_reduction":
        promoTypeValuePrefix = "产品立减";
        promoTypeValueSuffix = "元";
        break;
      case "promo_free_lowest":
        promoTypeValuePrefix = "立减最低价产品";
        break;
    }
    switch (exchangePromoType) {
      case "exchange_discount":
        exchangePromoTypeValuePrefix = "产品享";
        exchangePromoTypeValueSuffix = "折优惠";
        break;
      case "exchange_extra":
        exchangePromoTypeValuePrefix = "产品享固定价";
        exchangePromoTypeValueSuffix = "元";
        break;
    }

    const ruleStrs = tieredRules.map((rule) => {
      const {
        activityCondition,
        promoTypeValue,
        exchangeMaxQty,
        exchangePromoTypeValue,
      } = rule;
      const val1 = isConditionPrice
        ? formatPrice(activityCondition)
        : activityCondition;
      const ruleStr1 = `${promoTypeUnitPrefix}${val1}${promoTypeUnitSuffix}`;
      const ruleStr2 =
        promoType === "promo_na"
          ? ""
          : `，${promoTypeValuePrefix}${
              promoTypeValue || ""
            }${promoTypeValueSuffix}`;
      let exchangeRuleStr = "";
      if (basicType === "low_exchange") {
        const str1 =
          exchangePromoTypeValuePrefix || exchangePromoTypeValueSuffix
            ? `${exchangePromoTypeValuePrefix}${exchangePromoTypeValue}${exchangePromoTypeValueSuffix}，最多可换购`
            : "可换购";
        exchangeRuleStr = `${str1}${exchangeMaxQty}件`;
      }
      return {
        ruleStr: ruleStr1 + ruleStr2,
        exchangeRuleStr,
        matched: !!(currentTieredRule?.id === rule.id),
        unit: promoTypeUnitSuffix,
      };
    });
    return ruleStrs;
  };
  const { tieredRule, currentTieredRule } = props;
  if (!tieredRule) return null;
  const { tieredRules } = tieredRule;
  const ruleStrs = getPromotionRules(tieredRule, allowLinearTier);
  return (
    <div
      style={{
        paddingBottom: "20px",
      }}
    >
      <h3>优惠规则详情</h3>
      <p>
        <span>{activityDetail?.activityTypeName}: </span>
        <span>{tieredRule.activityTypeDescription}</span>
      </p>
      {basicType === "low_exchange" ? (
        <p>
          <span>{activityDetail?.exchangeTypeName}: </span>
          <span>{tieredRule.exchangeTypeDescription}</span>
        </p>
      ) : null}
      <div>
        {tieredRules?.map((rule, index) => {
          const ruleStr = ruleStrs[index];
          return (
            <div
              key={index}
              style={{
                margin: "14px 0",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 12px",
                  backgroundColor: "#efefef",
                  fontSize: "16px",
                  borderRadius: "6px 6px 0 0",
                }}
              >
                <span>
                  <span>{activityDetail?.activityTypeName}: </span>
                  <span>{ruleStr.ruleStr}</span>
                </span>
                {ruleStr.matched && props.matchStatus ? (
                  <span>
                    <img src={checkedImg} alt={"matched rule"}></img>
                  </span>
                ) : null}
              </div>
              {!!rule?.activityProductRule?.length ? (
                <div
                  style={{
                    padding: "10px 12px",
                    color: "#1b1b1d",
                  }}
                >
                  {rule?.activityProductRule?.map(
                    (productRule: any, index: number) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                        >
                          <span>{getRuleTypeName(productRule)}</span>
                          <span>{getRules(productRule)}</span>
                        </div>
                      );
                    }
                  )}
                </div>
              ) : null}
              {basicType === "low_exchange" ? (
                <div>
                  <p
                    style={{
                      padding: "10px 12px",
                      backgroundColor: "#efefef",
                      fontSize: "16px",
                    }}
                  >
                    <span>{activityDetail.exchangeTypeName}: </span>
                    <span>{ruleStr.exchangeRuleStr}</span>
                  </p>
                  {!!rule?.exchangeProductRule?.length ? (
                    <div
                      style={{
                        padding: "0 12px 10px 12px",
                        color: "#1b1b1d",
                      }}
                    >
                      {rule?.exchangeProductRule?.map(
                        (productRule: any, index: number) => {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                              }}
                            >
                              <span>{getRuleTypeName(productRule)}</span>
                              <span>{getRules(productRule)}</span>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          );
        })}
        {
            allowLinearTier && (<div style={{
              backgroundColor: "#fde4e4",
              padding: "10px 13px",
              borderRadius: "6px",
              fontSize: "16px",
              color: "#e71316",
            }}>
            <span>更多优惠： </span>
            <span>{ruleStrs[0].ruleStr}</span>
            <span>{ruleStrs[0].exchangeRuleStr ? `，${ruleStrs[0].exchangeRuleStr}` : ""}</span>
          </div>)
        }
      </div>
    </div>
  );
};

export default PromotionRules;
